// Real-artifact fixtures for Domain Intelligence tests. See README.md for
// provenance and slimming rules. Read-only — never mutate these in tests;
// deep-clone first if a test needs to modify one.

import dossier1268Severe from './dossiers/Store_Number_1268.json'
import dossier1012Moderate from './dossiers/Store_Number_1012.json'
import dossier1129Watch from './dossiers/Store_Number_1129.json'
import dossier1104Healthy from './dossiers/Store_Number_1104.json'

import metadataConfig from './config/metadata.json'
import definitionsConfig from './config/definitions.json'
import orchestrationConfig from './config/orchestration.json'
import queryPatternsConfig from './config/query_patterns.json'
import learningHistoryConfig from './config/learning_history.json'

import contextsIndex from './config/contexts/_index.json'
import balancedPawnTriangle from './config/contexts/balanced_pawn_triangle.json'
import baseHealthCheck from './config/contexts/base_health_check.json'
import deathSpiralDiagnosis from './config/contexts/death_spiral_diagnosis.json'
import deathSpiralScreening from './config/contexts/death_spiral_screening.json'
import inventoryParalysis from './config/contexts/inventory_paralysis.json'
import leadingIndicators from './config/contexts/leading_indicators.json'
import loanOperations from './config/contexts/loan_operations.json'
import originationDiagnosis from './config/contexts/origination_diagnosis.json'
import portfolioSustainability from './config/contexts/portfolio_sustainability.json'
import weeklyBrief from './config/contexts/weekly_brief.json'

export const clone = (value) => JSON.parse(JSON.stringify(value))

// One real dossier per canonical severity level (HO1 run, 2026-07).
export const dossiers = [
    dossier1268Severe,
    dossier1012Moderate,
    dossier1129Watch,
    dossier1104Healthy,
]

export const dossiersById = Object.fromEntries(dossiers.map((d) => [d.entityId, d]))

export const rootConfigFiles = {
    'metadata.json': metadataConfig,
    'definitions.json': definitionsConfig,
    'orchestration.json': orchestrationConfig,
    'query_patterns.json': queryPatternsConfig,
    'learning_history.json': learningHistoryConfig,
}

// Every live context, keyed by context name. `_index.json` is kept separate:
// it is the engine's Tier-1 selection surface, not a context.
export const contextConfigs = {
    balanced_pawn_triangle: balancedPawnTriangle,
    base_health_check: baseHealthCheck,
    death_spiral_diagnosis: deathSpiralDiagnosis,
    death_spiral_screening: deathSpiralScreening,
    inventory_paralysis: inventoryParalysis,
    leading_indicators: leadingIndicators,
    loan_operations: loanOperations,
    origination_diagnosis: originationDiagnosis,
    portfolio_sustainability: portfolioSustainability,
    weekly_brief: weeklyBrief,
}

export { contextsIndex }
